import { Stage } from './cookies/constants';

/**
 * Backend-facing stage for local development: when STAGE is Local, the dev
 * launcher's --backend flag selects whether backend clients talk to QA
 * (default — exactly the historical LOCAL→TEST collapse) or prod. Every
 * other stage resolves to itself, and an unset stage stays unset so
 * per-seam "stage unavailable" paths keep working. Reads
 * LOCAL_BACKEND_STAGE at call time (same convention as resolveStage); the
 * value is validated fail-closed by scripts/dev.mjs and
 * runtime/startup-config.cjs, and anything other than exactly 'prod'
 * collapses to the QA default.
 */
export function resolveBackendStage(stage: Stage | undefined): Stage | undefined {
  if (stage !== Stage.LOCAL) {
    return stage;
  }
  return process.env.LOCAL_BACKEND_STAGE === 'prod' ? Stage.PROD : Stage.TEST;
}

/** True when the backend-facing stage for this process is prod. */
export function isProdBackend(stage: Stage | undefined): boolean {
  return resolveBackendStage(stage) === Stage.PROD;
}
